module.exports = __webpack_public_path__ + "static/media/beth-rowbottom.a99d956c.jpg";